import Register from "./register.jsx"

export default Register